var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderMain',{attrs:{"title":"Документы"}}),_c('List',_vm._l((_vm.documents.data),function(item){return _c('CardDocument',{key:item.key,attrs:{"item":item}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }